interface PosSession {
  id: number;
  code: string;
  contact: string;
  date: string;
  startTime: string;
  endTime: string;
  correctBalance: boolean;
}

interface SaleByArticle {
  articleName: string;
  price: number;
  quantity: number;
  total: number;
}

interface SaleByAccount {
  accountNumber: string;
  accountName: string;
  analyticCode: string;
  taxRate: string;
  count: number;
  totalTaxAmount: number;
  totalAmount: number;
}

interface PaymentMethod {
  paymentMethodCode: string;
  paymentMethodLabel: string;
  totalAmount: number;
}

interface PaymentsByType {
  [key: string]: PaymentMethod;
}

interface PosError {
  id: number;
  code: string;
  message: string;
  date: string;
  posSessionId: number;
  posSessionCode: string;
}

interface CashError {
  positive: boolean;
  sign: string;
  totalAmount: number;
}

export interface PosSessionSyncInterface {
  id: number;
  date: string;
  journalCode: string;
  journalName: string;
  totalSales: number;
  totalPayments: number;
  totalMovements: number;
  totalErrors: number;
  validationStatus: string;
  syncStatus: string | null;
  posSessions?: PosSession[];
  salesByArticle?: SaleByArticle[];
  salesByAccount?: SaleByAccount[];
  paymentsByType?: PaymentsByType;
  errors?: PosError[];
  cashErrors?: CashError[];
  canBeSynced: boolean;
}

export interface PosSessionSyncFormModelInterface {
  id: number;
  date: string;
  pos_box_name: string;
  total_sales: number;
  total_payments: number;
  validation_status: ValidationStatus;
  sync_status: SyncStatus;
}

export enum ValidationStatus {
  Opened = 'opened',
  Closed = 'closed',
}

export enum SyncStatus {
  Pending = 'pending',
  Synced = 'synced',
  Failed = 'failed',
}

export const PosSessionSyncPermissionName: string = 'pos_sessions';

export interface PosSessionSyncDefaultFilterTableInterface {
  search?: string | null;
  validation_status?: string[];
  sync_status?: string[];
  date_from?: string | null;
  date_to?: string | null;
}

export type PosSessionDefaultTableItemInterface = PosSessionSyncInterface & {
  checked: boolean;
};

export type SaleDay = PosSessionSyncInterface & {
  code: string;
}; // TODO define it better
export interface SaleDaySyncEvent {
  tenantId: number;
  sessionCode: string;
  type: 'success' | 'error';
  reason?: string | null; // in case of error
  message?: string | null; // in case of error
  saleDay: SaleDay;
}
